export default __webpack_public_path__ + "static/media/bg2.a0b61fdf.png";